import { createSlice } from '@reduxjs/toolkit';

const spinnerSlice = createSlice({
    name: 'spinner',
    initialState: {
        loading: false,
    },
    reducers: {
        startSpinner: (state) => {
            state.loading = true;
        },
        endSpinner: (state) => {
            state.loading = false;
        },
    },
});

export const { startSpinner, endSpinner } = spinnerSlice.actions;
export default spinnerSlice.reducer;
